/**
 * The parts of a room the create wizard walks through and the room editor
 * opens on (CreateRoomWizard, RoomEditDialog, RoomToolbar): one icon each,
 * the same everywhere.
 */

import { LucideIcon, PaintRoller, PenLine, Ruler, Shapes, Tent } from 'lucide-react';
import { spaceLabel } from '../chrome/SpaceMenu';
import { DESIGNER_STRINGS as S } from '../strings';

export type RoomStep = 'name' | 'space' | 'size' | 'ceiling' | 'finish';

export const ROOM_STEP_ICON: Record<RoomStep, LucideIcon> = { name: PenLine, space: Shapes, size: Ruler, ceiling: Tent, finish: PaintRoller };

/** The Size step's title: the common sizes for this kind of space (just "Common sizes" for Other). */
export const sizeTitle = (spaceType: string) => S.planner.wizard.sizeTitle(spaceType === 'other' ? null : spaceLabel(spaceType));
